import {createFeatureSelector} from '@ngrx/store';
import {DripLessonConfigListState} from './drip-config-list.reducer';

export const selectDripConfigListState = createFeatureSelector<DripLessonConfigListState>("dripLessonsConfig");



